module.exports = __webpack_public_path__ + "fonts/6a931740caa3fe9fd674af3190849b21.svg";